/**
 * ``/workspace/projects`` route group — workspace surface for the per-
 * project management views (hub + detail).
 *
 * Why a parent route file with an Outlet (instead of two flat routes):
 *   - TanStack File-based routing requires a parent ``route.tsx`` for any
 *     nested ``$param.tsx`` segments. Without it the ``$projectId`` child
 *     never registers.
 *   - The parent intentionally renders only an ``<Outlet />`` because the
 *     hub and detail surfaces own DIFFERENT headers (the hub shows
 *     "Progetti" / count / "Nuovo" CTA, the detail shows the project name
 *     / breadcrumb / "Modifica"). Sharing a header here would force one of
 *     them to render two headers stacked. The Outlet pattern keeps each
 *     child a full ``SurfaceLayout`` of its own.
 *
 * Discoverability (Phase 0 wiring):
 *   - ProjectPill dropdown → "Gestisci progetti" (added in a follow-up
 *     edit to the ProjectPill itself; not part of this file).
 *   - Direct URL.
 *   - Command-K palette / UserMenu shortcut (Phase 4 will wire those).
 *
 * The route does NOT register in ``WORKSPACE_TAB_DEFS`` because the six
 * top-bar tabs are a fixed v18-mockup contract — same convention as
 * ``automations`` and ``templates``.
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

import { validateWorkspaceSearch } from "@/features/workspace-router";

export const Route = createFileRoute("/_authed/workspace/projects")({
  validateSearch: validateWorkspaceSearch,
  component: ProjectsShell,
});

function ProjectsShell() {
  return <Outlet />;
}
